module.exports = __webpack_public_path__ + "static/media/wPairs.89c57254.png";